let $ = require("jquery");
import _ from "underscore";
import render from "../../../utilities/render";
import {
  setElementsFromScope
} from '../../../utilities/selectorHelpers';
import { createPreventDefault } from '../../../utilities/general';
import EditChecker from '../../../components/EditChecker/EditChecker';
import { SUCCESS_MODAL_TIMEOUT } from "../../../constants";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";

import typeAheadSource from "../../../utilities/typeAheadSource";

const customValidateProps = {
  errorPlacement: function (error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};

const elementsPageMap = {
  errorMsgContainer: ".error-msg-container",

  createTeamMemberModalBtn: ".create-team-member-launch-modal",
  updateTeamMemberModalBtn: ".update-team-member-launch-modal",
  cancelTeamMemberEditCheckerBtn: ".cancel-and-launch-edit-checker",
  manageTeamMemberUserName: ".manage-team-member-user-name",
  manageTeamMemberUserEmail: "#emailAddress",

  manageTeamMembersForm: ".manage-team-members",
  userNameExistError: "#user-name-exist-error",
  userNameValidationError: "#user-name-validate-error",
  userEmailExistError: "#user-email-exist-error",
  phoneFormat: ".phone-format",

  //generics
  allSelect2Fields: ".select2-select",

  manufactureAccess: ".manufactureAccess",
  selectOrganization: ".select-organization-typeahead",
  manufactureAccessTypeAhead: "#mfg-access-typeahead",
  organizationTable:".organization-list",
  organizationSection:".after-user-adds-organizations",
  selectedOrgIdsPath:"#selected-org-ids",
  helpCenterButton:".manufacture-access-btn"
}

// NOTE: els within modals
const elementsModalsMap = {
  finishedCreatingMemberSaveMBtn: ".finished-save-m-btn",
  addAnotherMemberSaveMBtn: ".add-another-save-m-btn",
  finishedUpdatingMemberUpdateMBtn: ".finished-update-m-btn",
  genericModal: ".modal",
  closeBtn: ".top-close-btn"
}

export default function ManageBusinessLogic(mainEl) {
  const organizationsList = mainEl.data("organization-list");
  const userId = mainEl.data("user-id");
  const deleteOrgURL = mainEl.data("delete-org-url");
  const organizationRolesArray = mainEl.data("organization-roles-array");
  const manufactureAccessHelpCenterURL = mainEl.data("manufacture-access-help-url");
  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const self = this;

  const elsPage = {};
  const elsModals = {};

  let saveTeamMemberSuccessfulModal;
  let updateTeamMemberSuccessfulModal;

  self.init = function () {
    generateModals();
    setElements();
    setInitialState();
    bindElements();
    bindEditChecker();

  };
  // const updateModalFlow = new SubmitModalFlow({
  //   confirmModalTitle: 'Confirm Team Member',
  //   // confirmModalSubtitle: "Optional Subtitle",
  //   confirmModalBody: '<div class="q-pad-all-xl">Once you have confirmed this team member, an email will be sent to them with instructions to log in and update their temporary password.</div>',
  //   confirmModalBtnText: 'Update',
  //   onConfirmClick: function(){
  //     updateTeamMember();
  //
  //   }
  // });
  //
  // const createModalFlow = new SubmitModalFlow({
  //   confirmModalTitle: 'Confirm Team Member',
  //   // confirmModalSubtitle: "Optional Subtitle",
  //   confirmModalBody: '<div class="q-pad-all-xl">Once you have confirmed this team member, an email will be sent to them with instructions to log in and update their temporary password.</div>',
  //   confirmModalBtnText: 'Save',
  //   onConfirmClick: function(){
  //     createTeamMember();
  //
  //   }
  // });
  //
  // updateModalFlow.init();
  // createModalFlow.init();

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
    setElementsFromScope(elsModals, elementsModalsMap, mainEl);
    elsPage.manufactureAccess.hide();
  };

  function setInitialState() {
   
    elsPage.manageTeamMembersForm.validate(customValidateProps);
    elsPage.phoneFormat.inputmask({
      mask: "(999) 999-9999"
    });

    elsPage.errorMsgContainer.hide();

    instantiateOrgTypeAhead();
    if(userId != "") {
      let selectedRoleValue = elsPage.allSelect2Fields.find('option:selected').val();
      if (selectedRoleValue == organizationRolesArray[0].cdmValue || selectedRoleValue == organizationRolesArray[1].cdmValue) {
        elsPage.manufactureAccess.show();
      }
      else {
        elsPage.manufactureAccess.hide();
      }
      populateOrganizationTable(organizationsList);
    } 
    const orgNameLookup = elsPage.manufactureAccessTypeAhead;
    orgNameLookup.on("select2:select", function() {
          elsPage.organizationSection.removeClass("hidden");
          let res = orgNameLookup.select2('data')[0].typeAheadStr.split("--");
          addOrganizations(res[0],res[1],res[2],0);
          orgNameLookup.val(null).trigger('change');
    });
     
  };

  function populateOrganizationTable(organizationsList) {
    if(organizationsList.length > 0) {
      elsPage.organizationSection.removeClass("hidden");
      $.each(organizationsList, function(index, value) {
        let res = value.typeAheadStr.split("--");
        addOrganizations(res[0],res[1],res[2], res[3]);
      });
    }
  }

  function isOrganizationPresent(organizationList, orgId) {
    let isPresent= $.map(organizationList, function(elem, index) {
      if (elem == orgId || elem.id == orgId) {
        return true;
      }       
    });
    return isPresent; 
  }
 
  var addOrganizations = function(orgName,facilitiesCount,orgId, usoId) {
    let addedOrgIds = [];
    elsPage.organizationTable.find("a").each(function(index ) {
      addedOrgIds.push(this.id);
    });
    let isOrgPresent = isOrganizationPresent(addedOrgIds, orgId);
    //If Org not added previosuly only then allow to add it 
    if(isOrgPresent.length == 0) {
      const orgRow = $(render(
        require("../html/orgView.html"),{
          orgName: orgName,
          facilitiesCount: facilitiesCount,
          orgId: orgId,
          usoId: usoId
        }
      ));
      elsPage.organizationTable.append(orgRow);
    }
    
  }

  function bindElements() {
    //events from els on main page
    elsPage.createTeamMemberModalBtn.click(createPreventDefault(showCreateConfirmationModal));
    elsPage.updateTeamMemberModalBtn.click(createPreventDefault(showUpdateConfirmationModal));
    elsPage.allSelect2Fields.change(select2FieldChange);
    elsPage.manageTeamMemberUserName.change(createPreventDefault(checkUserName));
    elsPage.manageTeamMemberUserName.on('keyup', function(e){
      if($(this).val()==''){
        elsPage.userNameExistError.hide();
        elsPage.userNameValidationError.hide();
      }
    });
    elsPage.manageTeamMemberUserEmail.change(createPreventDefault(checkEmailId));
    elsPage.manageTeamMemberUserEmail.on('keyup', function(e){
      if($(this).val()==''){
        elsPage.userEmailExistError.hide();
      }
    });
    elsPage.helpCenterButton.on('click', function() {
      window.open(manufactureAccessHelpCenterURL);
    });

    //events from btns in modals
    elsModals.finishedCreatingMemberSaveMBtn.click(createPreventDefault(finishCreatingTeamMemberSaveM));
    elsModals.addAnotherMemberSaveMBtn.click(createPreventDefault(addAnotherTeamMemberSaveM));
    elsModals.finishedUpdatingMemberUpdateMBtn.click(createPreventDefault(finishCreatingTeamMemberUpdateM));

    elsModals.closeBtn.click(createPreventDefault(closeModalTopXBtnClick));
  };

  function bindEditChecker() {
    EditChecker.bindNavigation();

    //Set the listeners for change on main form element
    EditChecker.bindChangeListener(elsPage.manageTeamMembersForm);

    //Set listener for cancel button
    EditChecker.bindCancelButton(elsPage.cancelTeamMemberEditCheckerBtn);
  };

  function generateModals() {
    updateTeamMemberSuccessfulModal = $(render(
      require("../../../sharedHtml/modal.html"), {
        topCloseBtn: 'true',
        title: 'Update Successful',
        modalTitleClass: "q-text-left",
        footerBtns: '<a href="#" class="base-btn purple-btn finished-update-m-btn">Finished</a>',
        body: "<div class='q-marg-all-xl'>Your Team Member information has been updated and saved.</div>"
      }
    ));

    saveTeamMemberSuccessfulModal = $(render(
      require("../../../sharedHtml/modal.html"), {
        topCloseBtn: 'true',
        title: 'Save Successful',
        modalTitleClass: "q-text-left",
        footerBtns: '<a href="#" class="base-btn v2-btn purple-btn add-another-save-m-btn">Add Another Team Member</a>\
        <a href="#" class="base-btn purple-btn finished-save-m-btn">Finished</a>',
        body: "<div class='q-marg-all-xl'>Your Team Member has been saved and added. An email will be sent to the new member with instructions to log in and update their temporary password.</div>"
      }
    ));




    mainEl.append(saveTeamMemberSuccessfulModal);
    mainEl.append(updateTeamMemberSuccessfulModal);
  };

function instantiateOrgTypeAhead() {
  const select2AjaxDefaults = {
    dataType: 'json',
    delay: 250,
    async:false,
    processResults: function (data, params) {
      params.page = params.page || 1;
      return {
        results: data,
        pagination: {
          more: (params.page * 20) < data.total_count
        }
        };
    },
    cache: true
  };

  function configureDataCallback({paramKey}){
    return function(params){
      return {
        [paramKey] : params.term
      };
    };
  }

  elsPage.manufactureAccessTypeAhead.select2({
  placeholder: "Begin typing organization",
  allowClear: true,
  ajax: {
    ...select2AjaxDefaults,
    url: elsPage.manufactureAccessTypeAhead.data('get-org-list'),
    data: configureDataCallback({paramKey: 'likeOrg'}),
    templateResult: function(result){
      return result.text;
    }
  },
  minimumInputLength: 3
  });
}
  

  //NOTE: change event, so making it send functional jobs to another function
  function select2FieldChange() {
    handleSelect2IndividualValidate($(this));
  };


  //NOTE - this only needs to close modals, so I put that functionality directly in here
  function closeModalTopXBtnClick() {
    elsModals.genericModal.modal("hide");
  };


  // NOTE: since select2 components are tricky, we specifically target them as well with the EditChecker component, and also have to validate them individually
  function handleSelect2IndividualValidate(selectField) {
    selectField.valid();
    EditChecker.setPageDirty();
    //9023 Select Role Changes
    let selectedRoleValue = elsPage.allSelect2Fields.find('option:selected').val();
    if (selectedRoleValue == organizationRolesArray[0].cdmValue || selectedRoleValue == organizationRolesArray[1].cdmValue) {
      elsPage.manufactureAccess.show();
    }
    else {
      elsPage.manufactureAccess.hide();
    }
  };

  function createTeamMember() {
    let orgIdsList=[];
    if(elsPage.manufactureAccess.is(':visible')) {
      elsPage.organizationTable.find("a").each(function(index ) {
        orgIdsList.push(this.id);
      });
    }
  
    if (elsPage.manageTeamMembersForm.valid()) {
      elsPage.selectedOrgIdsPath.val(orgIdsList);
      saveTeamMemberCall();
    }
  };

  function updateTeamMember() {
    let orgIdsList=[];
    if(elsPage.manufactureAccess.is(':visible')) {
      elsPage.organizationTable.find("a").each(function(index ) {
        orgIdsList.push(this.id);
      });
    }
    if (elsPage.manageTeamMembersForm.valid()) {
      elsPage.selectedOrgIdsPath.val(orgIdsList);
      updateTeamMemberCall();
    }
  };

  function showUpdateConfirmationModal() {
    if (elsPage.updateTeamMemberModalBtn.attr("disabled") != "disabled") {
      updateTeamMember();
    }
  }

  function showCreateConfirmationModal() {
    if (elsPage.createTeamMemberModalBtn.attr("disabled") != "disabled") {
      createTeamMember();
    }
  }

  //NOTE - functions that handle modal els' events
  function finishCreatingTeamMemberSaveM() {
    //$("#manage-team-members").submit();
    elsPage.manageTeamMembersForm.submit();
  };

  function addAnotherTeamMemberSaveM() {
    //code to allow user to add another team member
  };

  function finishCreatingTeamMemberUpdateM() {
    elsPage.manageTeamMembersForm.submit();
  };

  //const submitModalFlow = new SubmitModalFlow();
  //submitModalFlow.init();


  // call this function on click of save button from manage team member screen
  function saveTeamMemberCall() {
    elsPage.errorMsgContainer.hide();
    var submitModalFlowVar = new SubmitModalFlow();
    submitModalFlowVar.init();
    submitModalFlowVar.showLoadingModal();
    $.ajax({
      url: elsPage.createTeamMemberModalBtn.data('url'),
      type: 'POST',
      dataType: 'json',
      data: elsPage.manageTeamMembersForm.serialize(),
      success: function (resp) {
        EditChecker.setPageClean();
        submitModalFlowVar.showSuccessModal();
        $('#userId').val(resp.data);
        setTimeout(function () {
          finishCreatingTeamMemberUpdateM();
        }, SUCCESS_MODAL_TIMEOUT);
      },
      error: function (xhr, status, error) {
        submitModalFlowVar.hide();
        elsPage.errorMsgContainer.show();
      }
    });
  }

  // call this function on click of update button from manage team member screen


  function updateTeamMemberCall() {
    elsPage.errorMsgContainer.hide();
    var submitModalFlowVar = new SubmitModalFlow();
    submitModalFlowVar.init();
    submitModalFlowVar.showLoadingModal();
    $.ajax({
      url: elsPage.updateTeamMemberModalBtn.data('url'),
      type: 'POST',
      dataType: 'json',
      data: elsPage.manageTeamMembersForm.serialize(),
      success: function (resp) {
        EditChecker.setPageClean();
        submitModalFlowVar.showSuccessModal();
        setTimeout(function () {
          finishCreatingTeamMemberUpdateM();
        }, SUCCESS_MODAL_TIMEOUT);
      },
      error: function (xhr, status, error) {
        submitModalFlowVar.hide();
        elsPage.errorMsgContainer.show();
      }
    });
  }

  var checkUserName = function () {
    elsPage.userNameExistError.hide();
    elsPage.userNameValidationError.hide();
    var inputValue = $("#screenName").val();
    checkDuplicateUserDetails('UserName', inputValue);
  }

  var checkEmailId = function () {
    var inputValue = $("#emailAddress").val();
    elsPage.userEmailExistError.hide();
    checkDuplicateUserDetails('EmailId', inputValue);
  }

  //Check duplicate user name
  var checkDuplicateUserDetails = function (inputType, inputValue) {
    if(inputType == 'UserName'){
      var pattern = /^[0-9a-zA-Z]+$/;
      if(!inputValue.match(pattern) && !inputValue == '') {
        elsPage.userNameValidationError.show();
      }
    }

    if (inputType.length > 0 && inputValue.length > 0) {
      $.ajax(
        {
          url: elsPage.manageTeamMemberUserName.data('check-user-name-url'),
          type: "GET",
          data: { inputValue: inputValue, inputType: inputType },
          beforeSend: function () {
            $.blockUI({ message: 'Checking User Name, Please Wait..' });
          },
          complete: function () {
            $.unblockUI();
          },
          success: function (data) {            
            if (data.trim() == 'true') {
              if (inputType == 'UserName') {
                elsPage.userNameExistError.show();
                elsPage.createTeamMemberModalBtn.attr('disabled', true);
                elsPage.updateTeamMemberModalBtn.attr('disabled', true);
              } else if (inputType == 'EmailId') {
                elsPage.userEmailExistError.show();
                elsPage.createTeamMemberModalBtn.attr('disabled', true);
                elsPage.updateTeamMemberModalBtn.attr('disabled', true);
              } else{
                elsPage.createTeamMemberModalBtn.attr('disabled', false);
                elsPage.updateTeamMemberModalBtn.attr('disabled', false);
              }

            } else {
              if (elsPage.userNameExistError.is(":visible") || elsPage.userEmailExistError.is(":visible") || elsPage.userNameValidationError.is(":visible")) {
                elsPage.createTeamMemberModalBtn.attr('disabled', true);
                elsPage.updateTeamMemberModalBtn.attr('disabled', true);
              }else{
                elsPage.createTeamMemberModalBtn.attr('disabled', false);
                elsPage.updateTeamMemberModalBtn.attr('disabled', false);
              }
            } 
          }
        });
    }
  }

  $(document).on("click", '.remove-org', function(e) {
    e.preventDefault();
    const orgId = this.id;
    const currentRow = $(this).closest(".org-row");
    const usoId = currentRow.data("uso-id");
    currentRow.remove();
  });
};



// WEBPACK FOOTER //
// ./src/pages/teamMembers/manage/manageBusinessLogic.js